import LocationAutoSelectSearch from "./location-autoselect-search";

export default LocationAutoSelectSearch;